import React from 'react';
import PropTypes from 'prop-types';
import { BoxWithHeading } from '@honda-canada/design-system-react';
import NoticeGrid from './NoticeGrid';
import themeStyles from './styles/ServiceNotices.styles';
import generateDataTestId from '../../utils/generateDataTestId';
import useConfiguration from '../../hooks/useConfiguration';

const Container = themeStyles.apply(BoxWithHeading, 'Container');
const TextAmount = themeStyles.apply('span', 'TextAmount');
const TitleText = themeStyles.apply('span', 'TitleText');
const Subtitle = themeStyles.apply('span', 'Subtitle');

const ServiceNotices = ({ data, hasBorder, shouldDisplayHeading }) => {
  const { counterColour } = useConfiguration();

  if (!data) {
    return null;
  }

  const { title, amountIdentifier, subtitle, contactCTA, serviceCTA, sections, status } = data;
  const noticesTitle = title.split(' ')[0].toLowerCase();

  const titleContent = (
    <>
      <TitleText data-testid={`cy-header-${noticesTitle}`}>{title}</TitleText>
      <TextAmount data-testid={generateDataTestId(title, 'counter')} counterColour={counterColour}>
        {amountIdentifier}
      </TextAmount>
    </>
  );

  const subtitleContent = <Subtitle data-testid={generateDataTestId(title, 'subtitle')}>{subtitle}</Subtitle>;

  return (
    <Container
      subtitleSize="regular"
      headingLevel="h4"
      data-testid={`cy-service-notices-${noticesTitle}`}
      hasBorder={hasBorder}
      titleContent={titleContent}
      subtitleContent={subtitleContent}
      shouldDisplayHeading={shouldDisplayHeading}
    >
      <NoticeGrid campaignSections={sections} contactCTA={contactCTA} serviceCTA={serviceCTA} status={status} />
    </Container>
  );
};

ServiceNotices.defaultProps = {
  shouldDisplayHeading: true,
};

ServiceNotices.propTypes = {
  shouldDisplayHeading: PropTypes.bool,
  hasBorder: PropTypes.bool,
  data: PropTypes.shape({
    title: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    subtitle: PropTypes.oneOfType([PropTypes.string, PropTypes.element]),
    amountIdentifier: PropTypes.string,
    contactCTA: PropTypes.shape({}),
    serviceCTA: PropTypes.shape({}),
    sections: PropTypes.arrayOf(PropTypes.shape({})),
    status: PropTypes.string.isRequired,
  }),
};

export default ServiceNotices;
